// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, permisoId }) => {
  const isAuthenticated = sessionStorage.getItem('isAuthenticated') === 'true';

  // EmpresaId SIEMPRE debe parsearse porque es un JSON.stringify([...])
  let empresaId = [];
  try {
    empresaId = JSON.parse(sessionStorage.getItem('EmpresaId') || '[]');
    if (!Array.isArray(empresaId)) empresaId = [];
  } catch {
    empresaId = [];
  }

  // 🔹 Leer raw
  let permisosRaw;
  try {
    permisosRaw = JSON.parse(sessionStorage.getItem('Permisos') || '[]');
  } catch {
    permisosRaw = [];
  }

  // 🔹 Normalizar siempre a array de números
  let permisos = [];
  if (Array.isArray(permisosRaw)) {
    permisos = permisosRaw
      .map((p) => Number(p))
      .filter((p) => !isNaN(p));
  } else if (typeof permisosRaw === 'number') {
    permisos = [permisosRaw];
  } else if (typeof permisosRaw === 'string') {
    // por si algún día lo guardas como "1,2,3"
    permisos = permisosRaw
      .split(',')
      .map((p) => Number(p.trim()))
      .filter((p) => !isNaN(p));
  }

  const permisoNecesario =
    permisoId !== undefined && permisoId !== null
      ? Number(permisoId)
      : null;

  // 🔒 No logueado
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // 🔒 No se ha seleccionado empresa
  if (empresaId.length === 0) {
    return <Navigate to="/company-selection" replace />;
  }

  // 🔒 Permiso requerido pero no lo tiene
  if (
    permisoNecesario !== null &&
    !Number.isNaN(permisoNecesario) &&
    !permisos.includes(permisoNecesario)
  ) {
    return <Navigate to="/acceso-denegado" replace />;
  }

  return children;
};

export default ProtectedRoute;
